import React from 'react';
import { Container, ErrorText } from './CustomErrorStyledComponents';
import { ErrorTypeCommon } from '../../interfaces/ErrorCode';
import { getErrorCodes } from '../../helpers/error-helper';

interface CustomErrorProps {
  errorCode: ErrorTypeCommon;
}

export const CustomError: React.FC<CustomErrorProps> = ({ errorCode }) => {
  const errorMessage = getErrorCodes(errorCode);

  return (
    <Container>
      <ErrorText>{errorMessage}</ErrorText>
    </Container>
  );
};
